import { render } from "./week.vue?vue&type=template&id=0acab7a8&lang=pug"
import script from "./week.vue?vue&type=script&setup=true&lang=js"
export * from "./week.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__